import api from '../../api/client';
// DefaultCyclePage.jsx
import React from "react";
import { Tabs, Card } from "antd";
import GoatsCyclePage from "./GoatsCycle";
import SheepCyclePage from "./SheepCycle";
import PigsCyclePage from "./PigsCycle";

const { TabPane } = Tabs;

export default function DefaultCyclePage() {
  return (
    <Card>
      <Tabs defaultActiveKey="goats" type="card">
        <TabPane tab="🐐 Goats" key="goats">
          <GoatsCyclePage />
        </TabPane>
        <TabPane tab="🐑 Sheep" key="sheep">
          <SheepCyclePage />
        </TabPane>
        <TabPane tab="🐷 Pigs" key="pigs">
          <PigsCyclePage />
        </TabPane>
      </Tabs>
    </Card>
  );
}